export default __webpack_public_path__ + "static/media/small_head_-5.f5cfec2b.webp";